// import { map } from "lodash";
import Auth from './Auth';
import { BaseModel } from './BaseModel';
import { checkRole } from './helpers/role-helper';
import UserRole from './UserRole';
// import UserEnrollment from "./UserEnrollment";

export class User extends BaseModel {
  static get entity() {
    return 'users';
  }

  static get fk() {
    return 'user';
  }

  static state() {
    return {
      isFetching: false
    };
  }

  static fields() {
    return {
      id: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      username: this.attr(null),
      user_roles: this.attr([]),
      uid: this.attr(null),
      jwt_token: this.attr(null),
      email: this.attr(null),
      description: this.attr(null),
      auth_source: this.attr(null),
      learning_units: this.attr([]),
      learning_unit_members: this.attr([]),
      user_enrollments: this.attr([]),
      applications: this.attr([]),
      sections: this.attr([]),
      date_of_birth: this.attr(null),
      phone_number: this.attr(null),
      current_occupation: this.attr(null),
      desired_occupation: this.attr(null),
      area_of_employment: this.attr(null),
      experience_level: this.attr(null),
      education_level: this.attr(null),
      goals: this.attr(null),
      like_to_learn: this.attr(null),
      know_us_from: this.attr(null),
      interested_micro_credentials: this.attr(null),
      confirmed: this.attr(false),
      is_old_user: this.attr(false),
      profile_picture: this.attr([]),
      original_profile_picture: this.attr([]),
      age: this.attr(null),
      country: this.attr(null),
      company: this.attr(null),
      is_onboarded: this.attr(false)
      /**
       *  ตรง field this.hasMany ต้อง comment ไปก่อนเพราะเหมือนว่า
       *  field user_enrollments จะยังไม่มาถ้าทำแบบนั้น
       *  แล้วใช้เป็น user_enrollments เฉยๆไปก่อน
       *
       *  มันจะกระทบตรงเปลี่ยนสถานะปุ่ม enroll ที่ user เคย enroll มาแล้ว
       */
      // user_enrollments: this.hasMany(UserEnrollment, User.fk),
    };
  }

  get name() {
    let name = '';

    if (this.firstname) {
      name += this.firstname;

      if (this.lastname) {
        name += ` ${this.lastname}`;
      }
    }

    return name;
  }

  userProfileText() {
    if (!this.name) return '';

    const words = this.name.split(' ');
    if (words.length === 1) return words[0][0].toUpperCase();
    const shortName = words[0][0] + words[words.length - 1][0];

    return shortName.toUpperCase();
  }

  isRole(roleName) {
    return checkRole(this, roleName);
  }

  isDesigner() {
    return checkRole(this, 'designer');
  }

  isReviewer() {
    return checkRole(this, 'reviewer');
  }

  isIssuer() {
    return checkRole(this, 'issuer');
  }

  isLearningUnitMemberOf(learningUnitId) {
    return this.learning_unit_members.some((lum) => lum.learning_unit === learningUnitId);
  }

  isInstructor() {
    const luInstructorRole = UserRole.learningUnitInstructor();
    return luInstructorRole
      ? this.learning_unit_members.some((lum) => lum.user_role === luInstructorRole.id)
      : false;
  }

  isInstructorOf(learningUnitId) {
    const luInstructorRole = UserRole.learningUnitInstructor();
    return luInstructorRole
      ? this.learning_unit_members.some(
          (lum) => lum.learning_unit === learningUnitId && lum.user_role === luInstructorRole.id
        )
      : false;
  }

  isAssessor() {
    const luAssessorRole = UserRole.learningUnitAssessor();
    return luAssessorRole
      ? this.learning_unit_members.some((lum) => lum.user_role === luAssessorRole.id)
      : false;
  }

  isAssessorOf(learningUnitId) {
    const luAssessorRole = UserRole.learningUnitAssessor();
    return luAssessorRole
      ? this.learning_unit_members.some(
          (lum) => lum.learning_unit === learningUnitId && lum.user_role === luAssessorRole.id
        )
      : false;
  }

  isOwnerOf(learningUnitId) {
    const luOwnerRole = UserRole.learningUnitOwner();
    const isOwner = this.learning_unit_members.some(
      (lum) => lum.learning_unit == learningUnitId && lum.user_role === luOwnerRole.id
    );
    return isOwner;
  }

  isOwner() {
    const luOwnerRole = UserRole.learningUnitOwner();
    const isOwner = luOwnerRole
      ? this.learning_unit_members.some((lum) => lum.user_role === luOwnerRole.id)
      : false;
    return isOwner;
  }

  canAccessLearn(learningUnitId) {
    return this.isOwnerOf(learningUnitId) || this.isReviewer() || this.isAssessorOf(learningUnitId);
  }

  canEditLearn(learningUnitId) {
    return this.isOwnerOf(learningUnitId) || this.isReviewer();
  }

  hasEnrollSection(id) {
    const { user_enrollments = [] } = this;

    return user_enrollments.some(({ section = {} } = {}) => section && section.id == id);
  }
  isGoogleUser() {
    return this.uid.includes('Google_');
  }

  static apiConfig = {
    actions: {
      // async fetchById(id, save = true) {
      //   return this.get(`/users?id=${id}`, {
      //     save: save
      //   });
      // },
      // /** */
      // fetchByUid(uid, save = true) {
      //   return this.get(`/users?uid=${uid}`, {
      //     save: save
      //   });
      // },

      fetchAuth() {
        return this.get(`/utilities/auth`);
      },

      async updateAuthLearningUnitMemberState() {
        const authData = User.query().first();

        if (authData) {
          const { response } = await this.get(`/utilities/auth/learning-unit-members`, {
            save: false
          });

          const { data } = response;

          authData.learning_unit_members = [...data];

          authData.$save();
        }
      },

      register(body) {
        return this.post(`/utilities/register`, body, { save: false });
      },

      registerByToken(body) {
        return this.post(`/utilities/register-by-token`, body, { save: false });
      },

      updateUser(body) {
        return this.put(`/users/me`, body);
      },

      resetPassword(body) {
        return this.post(`/utilities/reset-password`, body);
      },

      /**
       * send request to server for sending verifying email
       * @param {String} email
       */
      requestVerifyEmail(email) {
        return this.post(
          '/utilities/request-verify-email',
          { email },
          {
            headers: {
              Authorization: `Bearer ${Auth.getAppToken()}`
            },
            save: false
          }
        );
      },

      verifyEmail(token) {
        return this.post('/utilities/verify-email', { token }, { save: false });
      },
      revokeToken() {
        return this.post(
          '/utilities/auth/revoke-token',
          { refreshToken: Auth.getRefreshToken() },
          { save: false }
        );
      }
    }
  };
}

export default User;
